import { Link } from '@tanstack/react-router';
import ExternalLink from 'components/ExternalLink/ExternalLink.component';
import { withOneLineEllipsis } from 'style-utils/overflow';
import styled, { css } from 'styled-components';

export const NavbarWrapper = styled.nav`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  width: 100%;
  margin: 0;
  background: var(--site-header-bg);
  color: var(--site-header-text);
  overflow: hidden;
  z-index: 101;
  height: auto;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0px 4px 16px 0px #0000001f;
`;

export const WithBannerNavbarWrapper = styled(NavbarWrapper)`
  top: 75px;
`;

export const MenuTabsWrapper = styled(NavbarWrapper)`
  position: static;
  box-shadow: unset;
  background: transparent;
`;

const linkWithIconStyles = css`
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.24px;
  color: inherit;
  display: flex;
  padding: 0 16px 0 0;
  ${withOneLineEllipsis};
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
`;

export const SecondaryLinksWrapper = styled.ul`
  list-style: none;
  margin: 0;
  flex: 0 1 auto;
  display: flex;
  height: 100%;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;

  & > * {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    flex: 0 1 auto;
  }
`;

export const ExternalNavLink = styled(ExternalLink)`
  ${linkWithIconStyles};
  > span {
    display: none;
    @media (min-width: 1279px) and (orientation: landscape) {
      display: block;
    }
  }
`;

export const InternalNavLink = styled(Link)`
  ${linkWithIconStyles};
`;

export const LiWithColoredBorder = styled.li`
  background: var(--Neutrals-White, #fff);
  height: 100%;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 0 31px;
  height: 50px;
`;
